import pt from './pt';
import es from './es';

export default {pt, es};
